/**
 * サイドメニューに表示する項目の定義
 */
export namespace SideMenuTopic {
  /** トップページ */
  const TOP_PAGE: Topic = {
    text: 'トップページ',
    icon: '/img/icon/student/sidemenu/top.svg',
    url: '/student/top',
  }

  /** 知識マップ */
  const CURRICULUM_MAP: Topic = {
    text: '知識MAP',
    icon: '/img/icon/student/sidemenu/map.svg',
    url: '/student/map',
  }

  /** 復習ボックス */
  const RELEARNING_BOX: Topic = {
    text: '復習BOX',
    icon: '/img/icon/student/sidemenu/review.svg',
    url: '/student/review',
  }

  /** お知らせ一覧 */
  const NOTICE: Topic = {
    text: 'お知らせ',
    icon: '/img/icon/student/sidemenu/notice.svg',
    url: '/student/notice',
    subUrls: ['/student/notice/.*'],
  }

  /** マニュアル */
  const MANUAL: Topic = {
    text: 'マニュアル',
    icon: '/img/icon/student/sidemenu/map.svg',
    url: '/manual',
    target: '_blank',
  }

  /** メニュー項目一覧 */
  export const LIST: Topic[] = [TOP_PAGE, CURRICULUM_MAP, RELEARNING_BOX, NOTICE, MANUAL]

  /**
   * メニュー項目
   */
  export type Topic = {
    /** 表示する文字列 */
    text: string
    /** アイコンのパス */
    icon: string
    /** 遷移先URL */
    url: string
    /** 同じ項目内で表示する別のページのURL */
    subUrls?: string[]
    /** リンクのtarget要素に指定する値 */
    target?: string
  }
}
